import React, { useState } from 'react'
import styled from 'styled-components'
import { useTempBoolean } from '../../../hooks'
import * as Styled from './styled'

export type WizardTooltipPosition = 'top' | 'left' | 'right' | 'bottom'

const Container = styled.div`
  font-size: 14px;
  line-height: 20px;
  position: relative;
`

export const WizardTooltip: React.FC<{
  visibleOnHover: boolean
  visible?: boolean
  tooltipContent: React.ReactNode
  className?: string
  position?: WizardTooltipPosition
  temporary?: boolean
  timeout?: number
  tooltipContainerClassName?: string
}> = ({
  children,
  tooltipContent,
  className,
  visible = true,
  position = 'top',
  temporary,
  visibleOnHover,
  timeout = 1000,
}) => {
  const [hovered, setHovered] = useState(false)

  const handleMouseEnter = () => {
    setHovered(true)
  }
  const handleMouseLeave = () => {
    setHovered(false)
  }

  const isTooltipVisible = useTempBoolean(hovered, timeout, !temporary || (hovered && visibleOnHover)) && visible
  return (
    <Container className={className} onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave}>
      {children}
      {isTooltipVisible && !!tooltipContent ? (
        <Styled.WizardTooltipContainer position={position}>{tooltipContent}</Styled.WizardTooltipContainer>
      ) : null}
    </Container>
  )
}
